import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <section className="section not-found">
      <div className="container" style={{ textAlign: 'center' }}>
        <div className="section__eyebrow">404</div>
        <h1 className="section__title">Page Not Found</h1>
        <p className="section__lead" style={{ margin: '0 auto 32px' }}>
          That page doesn&rsquo;t exist. Head back home and try again.
        </p>
        <Link to="/" className="btn btn--primary">Back to Home</Link>
      </div>
    </section>
  );
}

export default NotFound;
